export { renderMenuDivider_unstable as renderMenuDivider } from '@fluentui/react-menu';
